import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["values"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import _map from 'lodash/map';
import { toMoment, getMomentValueOf } from '@tekion/tekion-base/utils/dateUtils';
var withDateAsFilter = function withDateAsFilter(WrappedComponent) {
  var WithDateAsFilter = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithDateAsFilter, _PureComponent);
    var _super = _createSuper(WithDateAsFilter);
    function WithDateAsFilter() {
      var _this;
      _classCallCheck(this, WithDateAsFilter);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (newValues) {
        var onChange = _this.props.onChange;
        onChange(_map(newValues, getMomentValueOf));
      });
      return _this;
    }
    _createClass(WithDateAsFilter, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          values = _this$props.values,
          rest = _objectWithoutProperties(_this$props, _excluded);
        var momentValues = _map(values, toMoment);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
          onChange: this.handleChange,
          values: momentValues,
          getValueFromProps: true
        }));
      }
    }]);
    return WithDateAsFilter;
  }(PureComponent);
  return WithDateAsFilter;
};
export default withDateAsFilter;